import { createTheme } from "@mui/material/styles"

const baseTheme = {
  typography: {
    allVariants: {
      fontFamily: ["Nunito"].join(","),
      textTransform: "none",
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginTop: 8,
          lineHeight: 1.1,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 42,
        },
      },
    },
  },
}

const lightColors = {
  mode: "light",
  palette: {
    primary: {
      main: "#0450DD",
      contrastText: "#fff",
    },
    secondary: {
      main: "#ED3640",
      contrastText: "#fff",
    },
    primary_light: {
      main: "#3673E4",
      light: "#42a5f5",
      dark: "#1565c0",
      contrastText: "#fff",
    },
    gray: {
      main: "#E0E6EF",
      light: "#E0E6EF",
      contrastText: "#7C828B",
    },
    bg: {
      main: "#0450DD",
      light: "#F1F4F9",
    },
    text: {
      dark: "#313131",
      middle: "#616567",
      light: "#fff",
    },
    background: {
      default: "#ffffff",
      paper: "#F1F4F9",
    },
  },
}

const darkColors = {
  mode: "dark",
  palette: {
    primary: {
      main: "#538df9",
      contrastText: "#fff",
    },
    secondary: {
      main: "#ff6b7d",
      contrastText: "#fff",
    },
    primary_light: {
      main: "#7aa3ff",
      light: "#a8c5ff",
      dark: "#2d68f7",
      contrastText: "#fff",
    },
    gray: {
      main: "#424242",
      light: "#616161",
      contrastText: "#b0b0b0",
    },
    bg: {
      main: "#0a1929",
      light: "#1a202c",
    },
    text: {
      dark: "#e0e0e0",
      middle: "#b0b0b0",
      light: "#ffffff",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
  },
}

export const createCustomTheme = (mode = "light", direction = "ltr") => {
  const colors = mode === "dark" ? darkColors : lightColors

  return createTheme({
    direction,
    palette: colors.palette,
    typography: baseTheme.typography,
    components: {
      ...baseTheme.components,
      // Адаптация под RTL
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            minWidth: 42,
            ...(direction === "rtl" && {
              marginRight: 0,
              marginLeft: 16,
            }),
          },
        },
      },
    },
  })
}

export default createCustomTheme()
